import React from "react";

import { RecentlyPublished } from "../../../../Task/tabs/ProfileDataTab/single/RecentlyPublished";

export const renderRecentlyPublished = (
  label,
  data,
  socialUrl,
  layout,
  GridBoxComponent,
  recentlyPublishedReady,
  setRecentlyPublishedReady,
) => {
  const { lastPostsData } = data;

  const height = layout?.find((item) => item.i === label)?.h;

  return (
    <GridBoxComponent key={label} id={label}>
      <RecentlyPublished
        lastPostsData={lastPostsData}
        socialUrl={socialUrl}
        height={height}
        provider={label}
        recentlyPublishedReady={recentlyPublishedReady}
        setRecentlyPublishedReady={setRecentlyPublishedReady}
      />
    </GridBoxComponent>
  );
};
